<template>
  <div>
    <div class="d-flex button-group justify-content-end">
      <b-popover target="load-files" placement="bottom"
                 ref="load-files-popover" :show.sync="popoverLoadFiles">
        <input enctype="multipart/form-data" type="file" ref="selectFile" @change="loadFile">
        <div class="d-flex button-group mb-0">
          <multiselect v-model="type" :max-height="200"
                       placeholder="Choose file type" label="name" track-by="name"
                       :options="typesForFiles" :multiple="false" :close-on-select="true"
                       select-label="" deselect-label="" selected-label="" :class="{ required: !type}"
          />
          <b-button class="btn" variant="success" size="sm" @click="chooseFile" :disabled="!type">
            {{$t('buttons.common.add')}}
          </b-button>
        </div>
      </b-popover>
      <b-button class="btn" id="load-files" variant="success" size="sm">
        {{$t('buttons.common.load_file')}}
      </b-button>
      <b-button class="btn" variant="danger" @click="deleteFile" size="sm">
        {{$t('buttons.documents.delete_file')}}
      </b-button>
      <b-button class="btn" @click="openFile" size="sm">{{$t('buttons.documents.open_file')}}</b-button>
    </div>
    <ag-grid-vue class="ag-theme-balham grid" :gridOptions="gridOptions"
                 :columnDefs="columns" :rowData="general_documents">
    </ag-grid-vue>
  </div>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue';
  import { Multiselect } from 'vue-multiselect';
  import { mapState } from 'vuex';
  import {
    getArrayByProperty,
    setNotifyData,
    getFile
  } from '@/helpers/commonHelpers';
  import { saveAs } from 'file-saver';

  export default {
    components: {
      'ag-grid-vue': AgGridVue,
      Multiselect
    },
    data() {
      return {
        typesForFiles: [
          {name: this.$t('labels.invoice.invoice'), key: 'invoice'},
          {name: this.$t('labels.common.operation'), key: 'operation'},
          {name: this.$t('labels.invoice.packing_list'), key: 'packing_list'}
        ],
        type: null,
        selectedFile: null,
        popoverLoadFiles: false
      }
    },
    methods: {
      chooseFile() {
        this.$refs['selectFile'].click();
      },
      loadFile() {
        const files = this.$refs['selectFile'].files;
        if (files.length) {
          for (let i = 0; i < files.length; ++i) {
            const headers = {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Content-Disposition': `form-data; filename=${encodeURIComponent(files[i].name)}`
            };
            getFile(files[i]).then((data) => {
              const requestBody = {
                'content': data.base64StringFile,
                'filetype': data.fileType,
                type: this.type && this.type.key
              };
              this.$http.post('woodware/templates/', JSON.stringify(requestBody), {headers}).then(() => {
                if (i === files.length - 1) {
                  this.$store.dispatch('woodware/loadGeneralDocuments');
                  this.popoverLoadFiles = false;
                }
              })
            });
          }
        }
      },
      deleteFile() {
        if (this.gridOptions.api.getSelectedRows().length) {
          const id = getArrayByProperty(this.gridOptions.api.getSelectedRows(), 'id')[0];
          this.$http.delete(`woodware/templates/${id}`).then(() => {
            this.$store.dispatch('woodware/loadGeneralDocuments');
            this.$notify(setNotifyData('Success', 'Succussfully deleted', 'success'));
          }).catch((error) => {
            console.log(error);
            this.$notify(setNotifyData('Error', 'Error while deleting', 'error'));
          });
        } else {
          this.$notify(setNotifyData('Error', 'Select document for removing', 'error'));
        }
      },
      openFile() {
        if (this.gridOptions.api.getSelectedRows().length) {
          const id = getArrayByProperty(this.gridOptions.api.getSelectedRows(), 'id')[0];
          this.$http.get(`woodware/templates/${id}`).then((response) => {
            const content = response.body.content;
            const uri = `data:${response.body['file_type']};base64,${content}`;
            fetch(uri)
              .then((file) => {
                file.blob()
                  .then((blob) => {
                    saveAs(blob, response.body['file_name']);
                  });
              });
          }).catch((error) => {
            console.log(error);
            this.$notify(setNotifyData('', 'Error has occurred', 'error'));
          });
        } else {
          this.$notify(setNotifyData('Error', 'Select document', 'error'));
        }
      }
    },
    beforeMount() {
      this.$store.dispatch('woodware/loadGeneralDocuments');
    },
    computed: {
      ...mapState('generalDocuments', ['gridOptions', 'columns']),
      ...mapState('woodware', ['general_documents']),
    }
  }

</script>

<style scoped>

  .grid {
    height: calc(100vh - 100px);
  }

  input[type='file'] {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/modules/general/documents/DocumentsList.vue